import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Contact3DBannerState } from './Contact3DBanner';
import { BannerCard } from '../../core/components/BannerCard';
export const Contact3DBannerCard = (props) => {
    const { bannerStateData, innerBannerProps } = props;
    if (bannerStateData.state === Contact3DBannerState.Announce) {
        const data = bannerStateData.data;
        if ('denyAnswer' in data) {
            return getDeniedBanner(data.secretWord, data.cluePlayer, data.clueSecret, data.denyAnswer, data.denyPlayer);
        }
        const upperText = 'newClueText' in data ? 'New clue!' : 'New letter!';
        const centerText = 'newClueText' in data ? `"${data.newClueText}"` : data.newLetterCurrentLetters.toUpperCase();
        const lowerText = 'newClueText' in data ? data.newCluePlayer : undefined;
        const highlightCenterTextColor = 'newClueText' in data ? undefined : '#D3E6F8';
        return _jsx(BannerCard, { borderColor: '#BDDCF8', color: '#7CBCF7', upperText: upperText, centerText: centerText, lowerText: lowerText, highlightCenterTextColor: highlightCenterTextColor, spaced: highlightCenterTextColor !== undefined });
    }
    if (bannerStateData.state === Contact3DBannerState.Contact) {
        if (props.contactIndex === undefined) {
            return _jsx(_Fragment, {});
        }
        if (props.contactIndex < 4) {
            let borderColor;
            let color;
            let centralText;
            let textColor;
            switch (props.contactIndex) {
                case 0:
                default:
                    borderColor = '#F2E8C8';
                    color = '#F0D395';
                    textColor = '#FFFFFF';
                    centralText = 'Contact!';
                    break;
                case 1:
                    borderColor = '#F7E5C7';
                    color = '#F9CF93';
                    textColor = '#FFFFDA';
                    centralText = '3...';
                    break;
                case 2:
                    borderColor = '#FFDBB7';
                    color = '#FBB88B';
                    textColor = '#FEFFD5';
                    centralText = '2...';
                    break;
                case 3:
                    borderColor = '#FCB3AF';
                    color = '#FF8E88';
                    textColor = '#FFF5AD';
                    centralText = '1...';
                    break;
            }
            return _jsx(BannerCard, { borderColor: borderColor, color: color, centerText: centralText, textColor: textColor, narrow: props.contactIndex > 0, innerBannerProps: innerBannerProps, transitionWidth: props.contactIndex === 1 });
        }
        const isGameOver = bannerStateData.clueSecret === bannerStateData.secretWord || bannerStateData.submittedAnswer === bannerStateData.secretWord || bannerStateData.isPenultimateLetter;
        const wasAnswerCorrect = bannerStateData.submittedAnswer === bannerStateData.clueSecret;
        const lightColor = isGameOver ? "#F8BDDC" : wasAnswerCorrect ? "#CDF8BD" : "#F8BDBD";
        const darkColor = isGameOver ? "#F77CBE" : wasAnswerCorrect ? "#9CF77C" : "#F77C7C";
        const upperText = isGameOver ? 'Game over!' : wasAnswerCorrect ? 'Correct!' : 'Wrong!';
        const centerText = isGameOver ? bannerStateData.secretWord.toUpperCase() : `"${bannerStateData.clueSecret}"`;
        let lowerText;
        let smallLowerText = false;
        if (isGameOver) {
            if (bannerStateData.clueSecret === bannerStateData.secretWord && bannerStateData.submittedAnswer === bannerStateData.secretWord) {
                lowerText = `${bannerStateData.answerPlayer} and ${bannerStateData.cluePlayer} guessed the secret word`;
                smallLowerText = true;
            }
            else if (bannerStateData.clueSecret === bannerStateData.secretWord) {
                lowerText = `${bannerStateData.cluePlayer} submitted the secret word`;
            }
            else if (bannerStateData.submittedAnswer === bannerStateData.secretWord) {
                lowerText = `${bannerStateData.answerPlayer} guessed the secret word`;
            }
            else if (bannerStateData.isPenultimateLetter) {
                lowerText = 'All letters have been revealed!';
            }
        }
        else if (wasAnswerCorrect) {
            lowerText = `${bannerStateData.cluePlayer} - ${bannerStateData.answerPlayer}`;
        }
        else {
            lowerText = `${bannerStateData.answerPlayer} - "${bannerStateData.submittedAnswer}"`;
        }
        return _jsx(BannerCard, { borderColor: lightColor, color: darkColor, centerText: centerText, upperText: upperText, lowerText: lowerText, spaced: isGameOver, smallLowerText: smallLowerText });
    }
    if (bannerStateData.state === Contact3DBannerState.Denied) {
        return getDeniedBanner(bannerStateData.secretWord, bannerStateData.cluePlayer, bannerStateData.clueSecret, bannerStateData.secretWordPlayerAnswer, bannerStateData.secretWordPlayer);
    }
    return _jsx(_Fragment, {});
};
function getDeniedBanner(secretWord, cluePlayer, clueSecret, denyAnswer, denyPlayer) {
    const isGameOver = secretWord === denyAnswer;
    const lightColor = isGameOver ? "#F8BDDC" : "#C5BDF8";
    const darkColor = isGameOver ? "#F77CBE" : "#8D7CF7";
    const upperText = isGameOver ? 'Game over!' : 'Denied!';
    const centerText = isGameOver ? secretWord.toUpperCase() : `"${denyAnswer}"`;
    const lowerText = isGameOver ? (clueSecret === secretWord ? `${cluePlayer} submitted the secret word` : `${denyPlayer} revealed the secret word`) : denyPlayer;
    return _jsx(BannerCard, { borderColor: lightColor, color: darkColor, centerText: centerText, upperText: upperText, lowerText: lowerText, spaced: isGameOver });
}
//# sourceMappingURL=Contact3DBannerCard.js.map